import React, { useEffect, useRef, useState } from 'react';
import { pdf } from '@react-pdf/renderer';
import { ResumePrint } from './ResumePrint';
import { pdfjs } from 'react-pdf';
import { getColorInfo } from '../../pages/ResumeBuilder/Components/DesignStep/constants';
import { PDFViewer } from '@react-pdf/renderer';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const wrapperStyle = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: 1005,
  minHeight: 1422,
  background: 'white',
  alignItems: 'flex-start',
}
const ResumeCanvasPreview = ({ resume }) => {
  const canvasRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [blobUrl, setBlobUrl] = useState(null);
  useEffect(() => {
    const generateBlob = async () => {
      const blob = await pdf(<ResumePrint resume={resume} />).toBlob();
      const url = URL.createObjectURL(blob);
      setBlobUrl(url);
    };

    generateBlob();
  }, [resume]);
  // useEffect(() => {
  //   let cancelled = false;
  //   setLoading(true);
  //   setError(null);
  //   (async () => {
  //     try {
  //       // 1. Generate PDF blob from ResumePrint
  //       const blob = await pdf(<ResumePrint resume={resume} />).toBlob();
  //       if (cancelled) return;
  //       // 2. Read blob as ArrayBuffer
  //       const arrayBuffer = await blob.arrayBuffer();
  //       if (cancelled) return;
  //       // 3. Load PDF with pdfjs
  //       const pdfDoc = await pdfjs.getDocument({ data: arrayBuffer }).promise;
  //       if (cancelled) return;
  //       // 4. Get first page
  //       const page = await pdfDoc.getPage(1);
  //       if (cancelled) return;
  //       // 5. Render to canvas
  //       const viewport = page.getViewport({ scale: 1.6 });
  //       const canvas = canvasRef.current;
  //       const context = canvas.getContext('2d');
  //       canvas.width = viewport.width;
  //       canvas.height = viewport.height;
  //       await page.render({ canvasContext: context, viewport }).promise;
  //       if (cancelled) return;
  //       setLoading(false);
  //     } catch (err) {
  //       if (!cancelled) {
  //         setError('Failed to render PDF preview.');
  //         setLoading(false);
  //       }
  //     }
  //   })();
  //   return () => {
  //     cancelled = true;
  //   };
  // }, [resume]);
  const selectedColor = getColorInfo(resume?.design?.color || 'black');
  return (
    <div style={wrapperStyle} className="resume-canvas-preview" >
     <PDFViewer width="100%" height="1000px"  showToolbar={false}>
      <ResumePrint resume={resume} />
     </PDFViewer>
    </div>
  );
};

export default ResumeCanvasPreview; 